import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Privacy Policy · Ram Shack";
  }, []);

  return (
    <main
      data-testid="privacy-policy-page"
      className="min-h-screen px-6 md:px-12 lg:px-16 py-24 max-w-3xl mx-auto"
    >
      <div className="overline mb-4">Ram Shack</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl text-bone mb-2">
        Privacy Policy
      </h1>
      <div className="text-xs uppercase tracking-[0.24em] text-muted-bone mb-12">
        Last updated · February 2026
      </div>

      <div className="space-y-8 text-muted-bone text-[15px] leading-relaxed">
        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">1. What we collect</h2>
          <p>
            We only collect information you knowingly give us so we can ship your order
            or reply to your questions. This includes name, shipping address, email,
            phone (optional), and payment tokens returned by our processor (Stripe).
            We never see your full card number. If you subscribe to our journal we
            store your email and the date you opted in.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">2. Age verification</h2>
          <p>
            Access to Ram Shack requires confirming you are 18 years or older
            (or 21 where applicable). We store a session flag confirming your
            attestation — we do not retain identity documents.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">3. Cookies and analytics</h2>
          <p>
            We use first-party cookies to keep you signed in and to remember your cart.
            Aggregate analytics (page views, referral source, device type) may be
            collected in de-identified form. We do not sell your data to third parties,
            ever.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">4. Discreet shipping</h2>
          <p>
            All orders ship in plain packaging with a neutral return name. Your
            purchase history is visible only to you (via your account) and to
            authorized Ram Shack staff who service orders. Suppliers who drop-ship
            on our behalf see only the shipping address and product SKU.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">5. Third parties</h2>
          <p>
            We share the minimum data required with these processors:
          </p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li>Stripe — payment processing (PCI-DSS Level 1)</li>
            <li>Resend / SMTP provider — order + newsletter emails</li>
            <li>Contracted suppliers — drop-shipping (address + SKU only)</li>
            <li>Emergent-managed Google Auth — optional social login</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">6. Your rights</h2>
          <p>
            You may request a copy of every piece of information we hold about you,
            or ask us to delete your account and all personal data, at any time.
            Write to <a href="mailto:privacy@ramshack.toys" className="text-bone underline">privacy@ramshack.toys</a>{" "}
            and we will confirm within 30 days.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">7. Security</h2>
          <p>
            Traffic is encrypted with TLS. Passwords are hashed with bcrypt.
            Payment card data never touches our servers — Stripe tokenizes at
            the browser. We audit access logs monthly.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">8. Contact</h2>
          <p>
            Ram Shack · privacy@ramshack.toys
          </p>
        </section>
      </div>
    </main>
  );
}
